module.exports = __webpack_public_path__ + "static/img/es.7775016.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/es.svg
// module id = FxNG
// module chunks = 4